import ReviewCard from "./ReviewCard";

const ListReviews = ({reviews}) => {
  return (
    <div className="w-full flex flex-col justify-start items-start gap-2 ">
      {reviews?.length &&
        [...reviews].reverse().map((review) => <ReviewCard review={review} />)}
    </div>
  );
};
export default ListReviews;
